var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 2.0624953,0.6874945 1.3749949,0 0,1.3749949 0.6874945,2.0624953 4.1249866,5.4999776 0.6874945,8.93746 0,9.6249215 1.3749949,11 2.0624953,10.312412 5.4999776,6.8749686 8.93746,10.312412 9.6249215,11 11,9.6249215 10.312412,8.93746 6.8749686,5.4999776 10.312412,2.0624953 11,1.3749949 9.6249215,0 8.93746,0.6874945 5.4999776,4.1249866 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1ccc9c2912a27ab8c81920b8d88d3e1d.svg";
export { ForwardRef as ReactComponent };